export function resolveElement(elOrSelector) {
  if (!elOrSelector) return null;
  if (typeof elOrSelector === 'string')
    return document.querySelector(elOrSelector);
  if (elOrSelector instanceof Element) return elOrSelector;
  return null;
}
